export const WORK_ORDER_SEARCH_TYPES = [
  {
    value: 'workOrderNumber',
    label: 'Work Order Number',
  },
  {
    value: 'erpId',
    label: 'ERP ID',
  },
  {
    value: 'customerOrderNumber',
    label: 'Customer Order Number',
  },
  {
    value: 'customerTitle',
    label: 'Customer Name',
  },
];

export const WORK_ORDER_STATUSES = [
  {
    value: 'all',
    label: 'ALL',
    color: '#6B7280',
    width: '60px',
  },
  {
    value: 'NEW',
    label: 'NEW',
    color: '#F59E0B',
    width: '70px',
  },
  {
    value: 'IN_PROGRESS',
    label: 'IN PROGRESS',
    color: '#3B82F6',
    width: '120px',
  },
  {
    value: 'PROCESSING',
    label: 'PROCESSING',
    color: '#3B82F6',
    width: '120px',
  },
  {
    value: 'CONFIRMED',
    label: 'CONFIRMED',
    color: '#10B981',
    width: '120px',
  },
  {
    value: 'SHIPPED',
    label: 'SHIPPED',
    color: '#10B981',
    width: '100px',
  },
  {
    value: 'PENDING',
    label: 'PENDING',
    color: '#F59E0B',
    width: '100px',
  },
]; 